import React from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import {
  IconButton,
  Badge,
  Popover,
  Typography,
  Box,
  Button,
  ListItemButton,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { VscRefresh } from "react-icons/vsc";
import { styled } from "@mui/material/styles";
import { CloseOutlined } from "@mui/icons-material";
import emptyIcon from "../../assets/Icons/empty_history.svg";
import messageIcon from "../../assets/Icons/message.png";
import { useQuery } from "@apollo/client";
import { GET_NOTIFICATION } from "../../Utils/Queries";
import moment from "moment";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));
const Notification = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const { data, loading, refresh } = useQuery(GET_NOTIFICATION);


  const sorted =
    data?.getAllNotifications?.items
      ?.slice()
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) || [];


  return (
    <>
      <IconButton aria-describedby={id} onClick={handleClick}>
        <StyledBadge badgeContent={0} color="error">
          <NotificationsIcon
            color="action"
            sx={{ color: "#000", fontSize: "20px" }}
          />
        </StyledBadge>
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ width: "300px", p: 2, boxShadow: "border-box" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{ color: "#151515", fontSize: "12px", fontWeight: 500 }}
            >
              Notification
            </Typography>
            <Box>
<IconButton onClick={refresh}>
  <VscRefresh />
</IconButton>
              <Button
                disabled={!data}
                variant="contained"
                sx={{ fontSize: "10px", mr: 1, borderRadius: 4 }}
              >
                Mark all as read
              </Button>
              <IconButton onClick={handleClose}>
                <CloseOutlined sx={{ fontSize: "12px" }} />
              </IconButton>
            </Box>
          </Box>
          <Box sx={{ mt: 3 }}>
            {!data?.getAllNotifications?.items ||
            data?.getAllNotifications?.items?.length === 0 ? (
              <>
                <Box
                  sx={{
                    height: "200px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={emptyIcon} />
                  <Typography
                    sx={{
                      mt: 1,
                      color: "#151515",
                      fontSize: "12px",
                      fontWeight: 600,
                    }}
                  >
                    No Notifications
                  </Typography>
                </Box>
              </>
            ) : (
              <>
                {sorted?.slice(0, 5)?.map((item, idx) => (
                  <ListItemButton
                    sx={{ borderBottom: "1px solid #F2F2F2", py: 1 }}
                    key={idx}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        columnGap: 2,
                        alignItems: "center",

                        width: "100%",
                      }}
                    >
                      <Box sx={{ width: "10%" }}>
                        <img src={messageIcon} alt="icon" width={25} />
                      </Box>
                      <div style={{ flex: 1, width: "85%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            columnGap: 1,
                          }}
                        >
                          <InputLabel
                            sx={{
                              fontSize: "12px",
                              color: "#000",
                              fontWeight: 500,
                            }}
                          >
                            {item?.title}
                          </InputLabel>
                          <Typography
                            sx={{ fontSize: "10px", whiteSpace: "nowrap" }}
                          >
                            {formatWithMoment(item?.createdAt)}
                          </Typography>
                        </Box>
                        <Typography className="two-line-ellipsis">
                          {item?.message}{" "}
                        </Typography>
                      </div>
                    </Box>
                  </ListItemButton>
                ))}

                <Button
                  fullWidth
                  sx={{ color: "primary.main", fontWeight: 500, mt: 1 }}
                >
                  See More
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default Notification;

function formatWithMoment(isoString) {
  const time = moment(isoString);
  const now = moment();

  const isToday = time.isSame(now, "day");

  return isToday
    ? `Today at ${time.format("h:mm A")}`
    : time.format("MMM D, YYYY [at] h:mm A");
}
